<template>
    <div class="picture-and-text" :class="alignContent">
        <div :class="{ column: isHorizontal }">
            <figure class="image" v-if="imgSrc">
                <LazyLoadedImage
                    :src="imgSrc"
                    alt="Placeholder image"
                ></LazyLoadedImage>
            </figure>
        </div>

        <div
            class="text-box ml-4 mr-5 my-3 py-6 hyphenate"
            :class="{ column: isHorizontal }"
        >
            <div class="title is-size-4 is-size-2-desktop">{{ title }}</div>
            <div class="subtitle is-uppercase">{{ subtitle }}</div>
            <div class="content has-text-grey-darker pt-3" v-html="text"></div>
        </div>
    </div>
</template>

<script>
import LazyLoadedImage from '../shared/LazyLoadedImage';

export default {
    name: 'PictureAndText.vue',
    components: { LazyLoadedImage },
    props: {
        contentData: {
            type: Object,
            required: true,
        },
    },
    computed: {
        imgSrc() {
            if (
                this.contentData.content.gallery &&
                this.contentData.content.gallery.rows[1]
            ) {
                return this.contentData.content.gallery.rows[1].columns[1]
                    .publicUrl;
            }
            return null;
        },
        title() {
            return this.contentData.content.header;
        },
        subtitle() {
            return this.contentData.content.subheader;
        },
        text() {
            return this.contentData.content.bodytext.replace(
                /(?:\r\n|\r|\n)/g,
                '<br>'
            );
        },
        positionHorizontal() {
            return this.contentData.content.gallery.position.horizontal;
        },
        positionVertical() {
            return this.contentData.content.gallery.position.vertical;
        },
        alignContent() {
            if (this.positionVertical === 'intext') {
                if (this.positionHorizontal === 'right') {
                    return 'align-right columns';
                } else {
                    return 'align-left columns';
                }
            } else if (this.positionVertical === 'below') {
                return 'align-below';
            } else return 'align-default';
        },
        isHorizontal() {
            if (this.positionVertical === 'intext') {
                if (this.positionHorizontal === 'right') {
                    return true;
                } else {
                    return true;
                }
            } else return false;
        },
    },
};
</script>

<style lang="scss">
.picture-and-text {
    width: auto;

    %align-default {
        max-width: 400px;
        margin: $size-1 auto 0 auto;
    }

    .align-default {
        @extend %align-default;
    }

    .align-below {
        @extend %align-default;
        display: flex;
        flex-direction: column-reverse;
        margin-top: 0;
    }
}

@media screen and (min-width: $tablet) {
    .picture-and-text {
        %align-horizontal {
            display: flex;
            padding: $size-2 15%;

            /*.figure {*/
            /*    display: block;*/

            /*    .image img {*/
            /*        height: 100%;*/
            /*        object-fit: cover;*/
            /*    }*/
            /*}*/

            .image {
                position: relative;
                overflow: hidden;
                height: 100%;

                img {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 100ms $easing;
                }
            }

            .text-box {
                display: block;
                /*flex-basis: 0;*/
                /*flex-grow: 1;*/
                /*flex-shrink: 1*/
            }
        }

        .align-left {
            @extend %align-horizontal;
        }

        .align-right {
            @extend %align-horizontal;
            flex-direction: row-reverse;
        }
    }
}

@media screen and (min-width: $desktop) {
    .cms-view-content {
        .cms-view__element.picture-and-text-view {
            margin: 2rem 8rem;
        }
    }
}
</style>
